import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../../services/index";
import { message } from "antd";

export const useFetchCustomfieldCase = (companyId) => {
  return useQuery(
    ["getFetchCustomfieldCase"],
    async () => {
      try {
        const endpoint = `/api/v1/caseCustomfield/list/${companyId}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Case Customfield..");
      }
    }
  );
};

export const UseFetchCreateCaseCustomfield = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/caseCustomfield`;
      const result = POST(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Create Case Customfield..");
    }
  });
};

export const UseFetchUpdateCaseCustomfield = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/caseCustomfield`;
      const result = PUT(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Update Case Customfield..");
    }
  });
};

export const UseFetchDeleteCaseCustomfield = () => {
  return useMutation(async (id) => {
    try {
      const endPoint = `/api/v1/caseCustomfield/${id}`;
      const result = await DELETE(endPoint);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Delete Case Customfield..");
    }
  });
};
